import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetInventoryReward {
  status?: string;
  search?: string;
  userin?: string;
  page?: number;
  size?: number;
}

export const getInventoryReward = ({
  status,
  search = '',
  page,
  size,
  userin = ''
}: GetInventoryReward) => {
  return HttpService.get(
    `${ApiService.icdc.module.inventoryReward.getListUser}?status=${status}&search=&page=1&take=10`
  );
};
